import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Icon, Tooltip, Typography } from "../../ui-v2";
import { InfoEntry } from "./types";

interface InfoProps {
  entry: InfoEntry;
}

const TooltipIconWrapper = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  color: theme.palette.secondary[3],
  fontWeight: "light",
  fontSize: "12px",
  cursor: "pointer",
  lineHeight: "8px",
}));

export const Info = (props: InfoProps) => {
  const { entry } = props;

  return (
    <Box
      sx={{
        color: "secondary.2",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {entry.label && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          <Typography color="secondary.2" fontWeight={400}>
            {entry.label}
          </Typography>
          {entry.tooltip && (
            <Tooltip title={entry.tooltip} arrow placement="left">
              <TooltipIconWrapper>
                <Icon size="medium" icon={faQuestionCircle} />
              </TooltipIconWrapper>
            </Tooltip>
          )}
        </Stack>
      )}
      <Typography
        variant="micro"
        color="secondary.2"
        maxWidth="100%"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {entry.value}
      </Typography>
    </Box>
  );
};
